module.exports = __webpack_public_path__ + "img/butantan.6415a915.svg";